'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

interface UseCouponCountParams {
  shopTitle: string;
  enabled?: boolean;
}

export const useCouponCount = ({ shopTitle, enabled = true }: UseCouponCountParams) => {
  const { data, isLoading } = useQuery({
    ...curatorQueries.coupon.count(shopTitle),
    enabled: !!shopTitle && enabled,
  });

  return {
    totalCount: data?.totalCount ?? 0,
    availableCount: data?.availableCount ?? 0,
    isLoading,
  };
};
